<dt-table-layout *dtDataLoad="tags != null; error: hasError" [isLoading]="isLoading">
  <form header class="cp-filters-form" [formGroup]="filterForm" (ngSubmit)="triggerLoadSubject.next()">
    <mat-form-field subscriptSizing="dynamic" class="search-query">
      <mat-label i18n>Zielname</mat-label>
      <input type="text" formControlName="searchQuery" matInput />
    </mat-form-field>
    <dt-tag-input [allTags]="tags" formControlName="tags" i18n>Nach Tags filtern</dt-tag-input>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label i18n>Ebene</mat-label>
      <mat-select formControlName="level">
        <mat-option [value]="null" i18n>Beliebig</mat-option>
        <mat-option value="only-fundamental" i18n>Nur Fundamentalziele</mat-option>
        <mat-option value="only-aspects" i18n>Nur Unterziele</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label i18n>Gruppieren nach</mat-label>
      <mat-select formControlName="groupBy">
        <mat-option [value]="null">—</mat-option>
        <mat-option value="nameDe" i18n>Deutschem Zielnamen</mat-option>
        <mat-option value="nameEn" i18n>Englischem Zielnamen</mat-option>
      </mat-select>
    </mat-form-field>
  </form>

  @if (!isGroupedList(items)) {
    <ng-container ngProjectAs="[mat-table]">
      <dt-quickstart-objectives-table
        [items]="items"
        [sort]="defaultSort"
        [tagsById]="tagsById"
        [selectedTags]="filterForm.value.tags"
        (sortChange)="onSortChange($event, 'default')"
        (tagClick)="tagClick($event)"
        (objectiveClick)="openModal($event)"
      ></dt-quickstart-objectives-table>
    </ng-container>
  }

  @if (isGroupedList(items)) {
    <table
      mat-table
      [dataSource]="items"
      matSort
      [matSortDisableClear]="true"
      [matSortActive]="groupedSort.sortBy"
      [matSortDirection]="groupedSort.sortDirection"
      (matSortChange)="onSortChange($event, 'grouped')"
    >
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Name</th>
        <td mat-cell *matCellDef="let row">
          {{ row.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="itemCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>#Zielbäume</th>
        <td mat-cell *matCellDef="let row">{{ row.items.length }}</td>
      </ng-container>
      <ng-container matColumnDef="accumulatedScore">
        <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>#Verwendet</th>
        <td mat-cell *matCellDef="let row">{{ row.accumulatedScore | number: '1.0-1' }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="groupedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: groupedColumns"
        dtElementRef
        #rowElement="dtElementRef"
        (click)="openGroupedDetails(rowElement, row)"
      ></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="groupedColumns.length" i18n>Keine Ziele entsprechen dem Filter.</td>
      </tr>
    </table>
  }

  <mat-paginator
    [pageSize]="page.pageSize"
    [pageIndex]="page.pageIndex"
    [length]="itemCount"
    [showFirstLastButtons]="true"
    (page)="onPageChange($event)"
  ></mat-paginator>
</dt-table-layout>

<ng-template #groupedDetailsPopover let-items>
  <div class="mat-elevation-z8 grouped-details-popover">
    <dt-quickstart-objectives-table
      [items]="groupedDetailItems"
      [tagsById]="tagsById"
      (objectiveClick)="openModal($event)"
    ></dt-quickstart-objectives-table>
  </div>
</ng-template>
